module.exports = __webpack_public_path__ + "img/checkbox_gray_dim_24.1dd44bad.svg";